import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Location } from "@angular/common";
import { KitService } from "src/shared/kit.service";

@Component({
  selector: "app-stepper",
  templateUrl: "./stepper.component.html",
  styleUrls: ["./stepper.component.scss"],
})
export class StepperComponent implements OnInit {
  public currentStep = "jersey";
  public lastCompletedStep;
  public isHiddenStepper: boolean = false;

  constructor(
    private readonly router: Router,
    private location: Location,
    private readonly kitService: KitService
  ) {
    this.router.events.subscribe((val) => {
      const path = this.location.path();
      this.currentStep = "jersey";
      if (path.includes("shorts-socks/step4")) {
        this.currentStep = "sock";
      } else if (path.includes("shorts-socks")) {
        this.currentStep = "short";
      } else if (path.includes("summary")) {
        this.currentStep = "summary";
      } else if (path.includes("contact-info")) {
        this.currentStep = "contact";
      } else if (path.includes("success")) {
        this.currentStep = "success";
      } else if (path.includes("failure")) {
        this.currentStep = "failure";
      } else if (path.includes("preorder")) {
        this.currentStep = "preorder";
      }
      this.lastCompletedStep = this.kitService.getStep();
    });
  }

  ngOnInit(): void {}

  goStepMaillot(event) {
    if (event.target.className) this.router.navigate(["customize"]);
  }

  goStepShort(event) {
    if (this.isStepCompleted(event)) {
      this.router.navigate(["shorts-socks/step1"]);
    }
  }

  goStepSocks(event) {
    if (this.isStepCompleted(event)) {
      this.router.navigate(["shorts-socks/step4"]);
    }
  }

  goStepSummary(event) {
    if (this.isStepCompleted(event)) {
      this.router.navigate(["summary"]);
    }
  }

  private isStepCompleted(event) {
    return event.target.className == "active";
  }
}
